export enum ActivityState {
  Unknown = 0,
  Published = 1,
  Unpublished = 2,
  Archived = 3,
  Cancelled = 4
}
